import React from 'react';

const AppSplash = () => {
  return (
    <div className="fixed inset-0 bg-[#1B3254] flex items-center justify-center">
      <div className="w-80 h-80 max-w-[80vw] max-h-[80vh]">
        <img 
          src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752683465914-blob" 
          alt="ILM Global Logo" 
          className="w-full h-full object-contain" 
        />
      </div>
    </div>
  );
};

export default AppSplash;